import { render, staticRenderFns } from "./ClassroomScreen.vue?vue&type=template&id=e6b34b7a&scoped=true"
import script from "./ClassroomScreen.vue?vue&type=script&lang=js"
export * from "./ClassroomScreen.vue?vue&type=script&lang=js"
import style0 from "./ClassroomScreen.vue?vue&type=style&index=0&id=e6b34b7a&prod&lang=less"
import style1 from "./ClassroomScreen.vue?vue&type=style&index=1&id=e6b34b7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b34b7a",
  null
  
)

export default component.exports